import { defineComponent as i, ref as n, computed as m, h as l } from "vue";
import a, { popoverBaseProps as h } from "./ghl-ui.es216.js";
import c from "./ghl-ui.es854.js";
import s from "./ghl-ui.es855.js";
import d from "./ghl-ui.es1130.js";
const f = Object.assign(Object.assign({}, h), s.props), b = i({
  name: "Tooltip",
  props: f,
  __popover__: !0,
  setup(e) {
    const {
      mergedClsPrefixRef: o
    } = c(e), r = s("Tooltip", "-tooltip", void 0, d, e, o), t = n(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        t.value.syncPosition();
      },
      setShow(p) {
        t.value.setShow(p);
      }
    }), {
      popoverRef: t,
      mergedTheme: r,
      popoverThemeOverrides: m(() => r.value.self)
    });
  },
  render() {
    const {
      mergedTheme: e,
      internalExtraClass: o
    } = this;
    return l(a, Object.assign(Object.assign({}, this.$props), {
      theme: e.peers.Popover,
      themeOverrides: e.peerOverrides.Popover,
      builtinThemeOverrides: this.popoverThemeOverrides,
      internalExtraClass: o.concat("tooltip"),
      ref: "popoverRef"
    }), this.$slots);
  }
});
export {
  b as default,
  f as tooltipProps
};
